import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Form,
  FormGroup,
  Input,
  Label,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { isLoggedIn } from '../../api/Auth';

import Avatar from '../Avatar';
import CommentsMentionsEditor from './Mentions/CommentsMentionsEditor';

const FileCommentForm = ({
  commentId,
  profile,
  share,
  isReply,
  commentValue,
  name,
  saving,
  errors,
  inputRefFunc,
  handleKeyPress,
  handleNameChange,
  handleCommentChange,
  handleCommentDurationChange,
  commentDuration,
  type,
}) => {
  const intl = useIntl();

  if (!profile && !share) {
    return null;
  }

  if (share && !share.allow_comments) {
    return null;
  }

  return (
    <Form className={`add-comment-form${isReply ? ' reply-comment-form' : ''}`}>
      <FormGroup>
        <Label className="add-comment-wrapper">
          <Avatar
            id={`comment-user-avatar-${profile?.uuid}-${commentId}`}
            user={profile}
            icon={profile ? 'user' : 'at'}
          />
          <div>
            {!isLoggedIn() && (
              <Input
                className={classnames('form-control comment-name', { disabled: saving })}
                name="name"
                placeholder={intl.formatMessage({ defaultMessage: 'Your name' })}
                value={name}
                onChange={handleNameChange}
                disabled={saving}
                invalid={errors.name}
                onKeyPress={handleKeyPress}
              />
            )}
            <div className="comment-content">
              <CommentsMentionsEditor
                commentValue={commentValue}
                handleCommentChange={handleCommentChange}
                handleKeyPress={handleKeyPress}
                inputRefFunc={inputRefFunc}
                isReply={isReply}
                disabled={saving}
              />
              {type === 'video' && (
                <>
                  <Input
                    id="comment-content-duration"
                    className={classnames('form-control comment-content-duration', { 'is-invalid': errors.commentDuration, disabled: saving })}
                    name="commentDuration"
                    placeholder={intl.formatMessage({ defaultMessage: 'Duration' })}
                    disabled={saving}
                    onChange={handleCommentDurationChange}
                    onKeyPress={handleKeyPress}
                    size={4}
                    defaultValue={commentDuration}
                    min={0.01}
                  />
                  <UncontrolledTooltip fade={false} placement="bottom" target="comment-content-duration">
                    {intl.formatMessage({ defaultMessage: 'Duration (seconds)' })}
                  </UncontrolledTooltip>
                </>
              )}
            </div>
          </div>
        </Label>
      </FormGroup>
    </Form>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  share: state.Shares.share,
});

FileCommentForm.propTypes = {
  profile: PropTypes.object,
  share: PropTypes.object,
  commentId: PropTypes.number,
  isReply: PropTypes.bool,
  commentValue: PropTypes.string,
  name: PropTypes.string,
  saving: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  inputRefFunc: PropTypes.func.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  handleCommentChange: PropTypes.func.isRequired,
  handleCommentDurationChange: PropTypes.func,
  handleKeyPress: PropTypes.func.isRequired,
  type: PropTypes.string,
  commentDuration: PropTypes.number,
};

FileCommentForm.defaultProps = {
  profile: null,
  share: null,
  commentId: null,
  isReply: false,
  commentValue: '',
  name: '',
  type: null,
  commentDuration: null,
  handleCommentDurationChange: () => {},
};

export default connect(mapStateToProps)(FileCommentForm);
